import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import Toggle from "../sidebar/Toggle";
import Logo from "../logo/Logo";
import User from "./dropdown/user/User";
import Notification from "./dropdown/notification/Notification";
import HeaderSearch from "../header-search/HeaderSearch";
import ChatDropdown from "./dropdown/chat/Chat";
import * as app_consts from "../../utils/app_consts";

import { useTheme, useThemeUpdate } from "../provider/Theme";
import { useSelector, useDispatch } from "react-redux";
import { employee_channel_actions_helper } from "../../actions/actions_helper";
import AnnouncementMarquee from "../../components/AnnouncementMarquee";
import { reset_announcements_update } from "../../reducers/auth_tenant/announcements_update_Slice";

const Header = ({ fixed, logo, className, ...props }) => {
  const theme = useTheme();
  const themeUpdate = useThemeUpdate();
  const [user_info, setUserInfo] = useState(null);
  const [tenant_info, setTenantInfo] = useState(null);
  const dispatch = useDispatch();
  const [announcement_data, setAnnouncementData] = useState([]);

  // For dynamically measuring header height
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  // Get tenant information from Redux store
  const user_information = useSelector(
    (state) => state.retrieve_tenant_user_information.retrieve_tenant_user_information
  );

  // Update state and navigate when tenant information is available
  useEffect(() => {
    if (user_information?.status === app_consts.SUCCESS)
    {
      if (user_information?.data?.access_level === app_consts.EMPLOYEE)
      {
        dispatch(employee_channel_actions_helper(true));
      } else
      {
        // handle other user types if needed
      }
      setUserInfo(user_information.data);
    } else
    {
      dispatch(employee_channel_actions_helper(false));
    }
  }, [user_information, dispatch]);

  // Get tenant information from Redux store
  const tenant_information = useSelector(
    (state) => state.retrieve_tenant_information.retrieve_tenant_information
  );

  // Update state and navigate when tenant information is available
  useEffect(() => {
    if (tenant_information?.status === app_consts.SUCCESS)
    {
      setTenantInfo(tenant_information.data);
    }
  }, [tenant_information]);

  // Listen to Announcement Data
  const announcement_data_listener = useSelector(
    (state) => state.announcements_update.announcements_update
  );

  useEffect(() => {
    if (announcement_data_listener?.status !== app_consts.IDLE)
    {
      if (announcement_data_listener?.status === app_consts.SUCCESS)
      {
        setAnnouncementData(announcement_data_listener?.data?.announcements || []);
      } else
      {
        setAnnouncementData([]);
      }
      dispatch(reset_announcements_update());
    }
  }, [announcement_data_listener]);

  // Dynamically measure the header height
  useEffect(() => {
    if (headerRef.current)
    {
      const resizeObserver = new ResizeObserver(() => {
        setHeaderHeight(headerRef.current.offsetHeight);
      });
      resizeObserver.observe(headerRef.current);
      return () => resizeObserver.disconnect();
    }
  }, [announcement_data]);

  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
    [`is-light`]: theme.header === "white",
    [`is-${theme.header}`]: theme.header !== "white" && theme.header !== "light",
    [`${className}`]: className,
  });

  return (
    <>
      <div
        ref={headerRef}
        className={headerClass}
        style={{
          position: fixed ? "fixed" : "relative",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          display: "flex",
          flexDirection: "column",
          height: "auto",
          minHeight: "64px",
          background: theme.header === "white" ? "#fff" : "#f8f9fa",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        }}
      >
        <div
          className="container-fluid"
          style={{
            flex: "1 0 auto",
            width: "100%",
          }}
        >
          <div
            className="nk-header-wrap"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              height: "64px",
            }}
          >
            <div className="nk-menu-trigger d-xl-none ms-n1">
              <Toggle
                className="nk-nav-toggle nk-quick-nav-icon d-xl-none ms-n1"
                icon="menu"
                click={themeUpdate.sidebarVisibility}
              />
            </div>
            <div className="nk-header-brand d-xl-none">
              <Logo logo={logo} />
            </div>

            {/* <div className="nk-header-search ms-3 ms-xl-0">
              <HeaderSearch />
            </div> */}

            <div className="nk-header-tools">
              <ul
                className="nk-quick-nav"
                style={{
                  margin: 0,
                  padding: 0,
                  listStyle: "none",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <li
                  className="chats-dropdown hide-mb-xs"
                  onClick={themeUpdate.sidebarHide}
                >
                  <ChatDropdown />
                </li>
                <li
                  className="notification-dropdown me-n1"
                  onClick={themeUpdate.sidebarHide}
                >
                  <Notification />
                </li> */}
                <li
                  className="user-dropdown"
                  onClick={themeUpdate.sidebarHide}
                  style={{ cursor: "pointer" }}
                >
                  <User user_info={user_info} tenant_info={tenant_info} />
                </li>
              </ul>
            </div>
          </div>
        </div>

        {
          announcement_data && announcement_data?.length > 0 &&
          (
            <>
              {/* Announcement Marquee Section */}
              <div
                style={{
                  flexShrink: 0,
                  width: "100%",
                  background: "#f8f9fa",
                  padding: "4px 0",
                }}
              >
                <AnnouncementMarquee data={announcement_data} />
              </div>
            </>
          )
        }
      </div>

      {/* Spacer div for fixed header (pushes content below) */}
      {fixed && (
        <div
          style={{
            height: `${headerHeight}px`,
          }}
        ></div>
      )}
    </>
  );
};

export default Header;
